const BlockEmbed = Quill.import('blots/block/embed');
import { Quill } from 'vue-quill-editor'

// Создаем шаблон для файлов типо документ
export class DocumentBlot extends BlockEmbed {
    static create(val) {
        let node = document.createElement("a")
        node.setAttribute('href', val.path);
        node.setAttribute('target', '_blank');
        node.setAttribute('download',"download");
        node.innerHTML = val.name
        return node;
    }
  
    static value(node) {
        return node.getAttribute('href');
    }
}
DocumentBlot.blotName = 'doc';
DocumentBlot.tagName = 'doc';

// Создаем шаблон для файлов типо аудио
export class AudioBlot extends BlockEmbed {
    static create(url) {
        let node = super.create();
        node.setAttribute('src', url);
        node.setAttribute('controls', '');
        return node;
    }
  
    static value(node) {
        return node.getAttribute('src');
    }
}
AudioBlot.blotName = 'audio';
AudioBlot.tagName = 'audio';

// Создаем шаблон для кнопки редактирования html
export class HtmlEditor {
    constructor(quill, options = {}) {
        this.quill = quill;
        this.options = options;

        this.addTextarea();
        this.bindEditorBehavior();
        this.bindButtonBehavior();
    }

    addTextarea() {
        let container = this.quill.addContainer('ql-custom');

        this.textarea = document.createElement('textarea');
        this.textarea.className = "ql-edit-html-textarea";
        this.textarea.style.display = "none";

        container.appendChild(this.textarea);
    }

    bindEditorBehavior() {
        let editor = document.querySelector('.ql-editor');

        this.quill.on('text-change', () => {
            if (editor) {
                let html = editor.innerHTML;

                this.textarea.value = html;
            }
        });
    }

    bindButtonBehavior() {
        let button = document.querySelector('.ql-edit-html');

        if (button) {
            button.addEventListener('click', () => {
                if (this.textarea.style.display === '') {
                    let html = this.textarea.value;

                    this.quill.pasteHTML(html);
                }

                this.textarea.style.display =
                    this.textarea.style.display === 'none'
                        ? ''
                        : 'none';
            });
        }
    }
}